import React from 'react';
import { toFormatUtcDate } from '../../utils/date';
import ShowLastNoteIcon1 from '../showLastNoteIcon/showLastNoteIcon1';

const rowStyle = { display: 'inline-flex', alignItems: 'center', gap: 6 };

interface Props {
    /** UTC, with or without its time zone depending on the deployed API (see toFormatUtcDate). */
    date?: string | null;
    /** The last note of that kind, as JSON: it carries the threshold colour of the picto. */
    note?: string | null;
    tag: string;
}

/** The date of the last maintenance or emptying with its threshold picto; N/A when there is none. */
const LastNoteField = ({ date, note, tag }: Props) => (
    <span style={rowStyle}>
        <span>{date ? toFormatUtcDate(date) : 'N/A'}</span>
        {date && <ShowLastNoteIcon1 record={note ?? null} tag={tag} />}
    </span>
);

export default LastNoteField;
